export const SET_PENDING = 'setPending';
export const SET_ERROR = 'setError';
export const SET_DOC_TITLE = 'setDocTitle';
